import React from 'react';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import WelcomeBlurb from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/WelcomeBlurb';

const styles = (theme) => ({
  root: {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    maxWidth: '500px',
    flexDirection: 'column',
    marginBottom: theme.spacing(10),
    padding: theme.spacing(2),
  },
  fields: {},
  informationContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
  },
  keyValuePair: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(3),
  },
});

function Layout({
  classes,
}) {
  const {
    resource,
  } = useMetaLayoutContext();

  const bulletPoints = resource.attr('subtitle').map(point => {
    return { text: point };
  });
  return (
    <div className={classes.root}>
      {resource?.attr('title')
        ? <Title className={classes.title} text={resource.attr('title')} test={'wizard-step-title'} /> : null}

      <WelcomeBlurb
        className={classes.welcomeBlurb}
        title={'ESG investing is newer compared to other investment strategies and therefore it comes with a couple of additional considerations and risks:'}
        bullets={bulletPoints}
      />
    </div>
  );
}

Layout.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
